import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import { Save, X } from "lucide-react";

interface AddNewDocumentGroupProps {}

interface FormData {
  groupName: string;
  department: string;
  recipient: string;
}

const AddNewDocumentGroup: React.FC<AddNewDocumentGroupProps> = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<FormData>({
    groupName: "",
    department: "",
    recipient: "",
  });

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Saving document group data:", formData);
    // TODO: Implement save functionality
    navigate("/documents/groups");
  };

  const handleCancel = () => {
    navigate("/documents/groups");
  };

  // Mock data for departments
  const departments = [
    "- Chọn phòng ban -",
    "Ban Lãnh đạo",
    "Phòng Khoa học Công nghệ",
    "Phòng Tài chính Kế toán",
    "Trung tâm Thí nghiệm",
    "Phòng Tổ chức Hành chính",
    "Phòng Kế hoạch Tổng hợp",
  ];

  return (
    <PageShell title="Thêm mới nhóm nhận văn bản">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm mới nhóm nhận văn bản
          </h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="bg-gray-50 p-4 rounded-lg">
            <div className="space-y-4">
              {/* Tên nhóm */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tên nhóm <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.groupName}
                  onChange={(e) =>
                    handleInputChange("groupName", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập tên nhóm..."
                />
              </div>

              {/* Grid layout for other fields */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Phòng ban */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phòng ban <span className="text-red-500">(*)</span>
                  </label>
                  <select
                    value={formData.department}
                    onChange={(e) =>
                      handleInputChange("department", e.target.value)
                    }
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    {departments.map((dept, index) => (
                      <option key={index} value={index === 0 ? "" : dept}>
                        {dept}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Người nhận */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Người nhận <span className="text-red-500">(*)</span>
                  </label>
                  <input
                    type="text"
                    value={formData.recipient}
                    onChange={(e) =>
                      handleInputChange("recipient", e.target.value)
                    }
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Nhập tên người nhận..."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex justify-end gap-2">
          <button
            onClick={handleCancel}
            className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md text-sm font-medium hover:bg-gray-400 transition-colors flex items-center space-x-2"
          >
            <X className="w-4 h-4" />
            <span>Hủy</span>
          </button>
          <button
            onClick={handleSave}
            className="bg-green-600 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-green-700 transition-colors flex items-center space-x-2"
          >
            <Save className="w-4 h-4" />
            <span>Lưu dữ liệu</span>
          </button>
        </div>
      </div>
    </PageShell>
  );
};

export default AddNewDocumentGroup;
